<template>
    <transition name="slide-fade">
        <div class="modal" :class="{'open' : open}" v-if="open" data-cy="modal_marketing_main">
            <div class="modal-content" data-cy="container_modal_marketing_content">
                <div class="bg-white w-full rounded-xl p-3" data-cy="container_modal_marketing_body">
                    <div class="py-2" data-cy="text_modal_marketing_title">
                        Marketing option
                    </div>
                    <div class="mb-2" data-cy="container_modal_marketing_option_email">
                        <Checkbox data-cy="checkbox_modal_marketing_option_email" v-model:check="option.email">Email</Checkbox>
                    </div>
                    <div class="mb-2" data-cy="container_modal_marketing_option_sms">
                        <Checkbox data-cy="checkbox_modal_marketing_option_sms" v-model:check="option.sms">SMS</Checkbox>
                    </div>
                    <div class="mb-2" data-cy="container_modal_marketing_option_line">
                        <Checkbox data-cy="checkbox_modal_marketing_option_line" v-model:check="option.line">Line</Checkbox>
                    </div>
                    <div class="mb-2" data-cy="container_modal_marketing_option_notification">
                        <Checkbox data-cy="checkbox_modal_marketing_option_notification" v-model:check="option.notification">Notification</Checkbox>
                    </div>
                    <div class="mb-2" data-cy="container_modal_marketing_option_ussd">
                        <Checkbox data-cy="checkbox_modal_marketing_option_ussd" v-model:check="option.ussd">ussd</Checkbox>
                    </div>
                    <div class="w-1/2 m-auto" data-cy="container_modal_marketing_actions">
                        <button class="w-full bg-blue-600 text-white rounded-md py-1" data-cy="btn_modal_marketing_save" @click="clickSaveOption()">
                            Save
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </transition>

    <transition name="fade">
        <div class="modal-backdrop" v-if="open" data-cy="container_modal_marketing_backdrop"></div>
    </transition>
</template>
<script>
import LocaleMixin from "@/mixin/LocaleMixin.js";
import Checkbox from '@/components/Input/simple/Checkbox.vue';

export default {
    name: "MarketingOptionModal",
    mixins: [LocaleMixin],
    components: {
        Checkbox,
    },
    props: {
        controller: Object,
    },
    data: function() {
        return {
            open: false,
            busModal: null,

            option: {
                email: false,
                sms: false,
                line: false,
                notification: false,
                ussd: false, // phone network message
            },
        };
    },
    created: function() {
        this.busModal = this.controller.busModal;
    },
    mounted: function() {
        this.busModal.on('show', this.show);
        this.busModal.on('hide', this.hide);
    },
    watch: {
        '$route.path': function() {
            if (this.open) {
                this.hide();
            }
        },
    },
    methods: {
        show: function(config) {
            if (config.enableAll) {
                this.enableAll();
            } else if (config.disableAll) {
                this.disableAll();
            }

            document.body.classList.add('not-scroll');
            this.open = true;
        },
        hide: function() {
            document.body.classList.remove('not-scroll');
            this.open = false;
        },
        enableAll: function() {
            this.option.email = true;
            this.option.sms = true;
            this.option.line = true;
            this.option.notification = true;
            this.option.ussd = true;
        },
        disableAll: function() {
            this.option.email = false;
            this.option.sms = false;
            this.option.line = false;
            this.option.notification = false;
            this.option.ussd = false;
        },
        // clickOk: function () {
        //     this.hide();
        //     this.controller.sendCallbackOk();
        // },
        clickSaveOption: function() {
            this.controller.sendCallbackSave(this.option);
            this.hide();
        },
    },
}
</script>
<style lang="scss" scoped>
    @import "@/style/modal.scss";
    .modal {
        @extend %modal;
    }
</style>
